import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DropdownLayout_1 from "../../../../components/Dropdown/DropdownLayout_1";
import DropdownVoucherDynamicInput from "../../../../components/Dropdown/DropdownVoucherDynamicInput";
import DropdownForItemLedgerDynamic from "../../../../components/Dropdown/DropdownForItemLedgerDynamic";
import { dummy_units_array } from "../../../../components/Dummi_Data";



export const VoucherSalesPurchaseInputRow = ({
  data,
  setData,
  handleChange,
  handleFocus,
  handleBlur,
  inputRefs,
  itemData,
  dropList,
  narr_ref,
  itemLedgerData,
  handleDropdownDynamicClick,
  godownLocationItem,
}) => {
  const modal_state = useSelector((state) => state.common.modal_state);
  

  return (
    <div
      className="row m-0 p-0"
      style={{ height: "33vh", overflowY: "scroll" }}
    >
      <div className="col-12">
        <div className="row">
          {data?.data_item?.map((item, index) => {
            return (
              <div
                key={index}
                className={`col-12`}
                style={{ height: 19.5, backgroundColor: "transparent" }}
              >
                <div className="row" style={{ height: 19.5 }}>
                  <div
                    className={`col-1 m-0 p-0 ps-1 pe-1 font-weight-bold text-end ${
                      item?.check_open ? "" : ``
                    }`}
                    style={{ width: "3%", height: 19.5 }}
                  >
                    {data?.data_item[index]?.item_name === ""
                      ? ""
                      : data?.data_item[index]?.id}
                  </div>
                  <div
                    className={`col-4 m-0  p-0  ${
                      data?.location === "Any"
                        ? item?.check_open
                          ? ""
                          : ``
                        : ""
                    } container_of_voucher_dynamic_input`}
                  >
                    <input
                      type="text"
                      name={`item_name${index}`}
                      ref={(el) => {
                        inputRefs.current[`item_name${index}`] = el;
                      }}
                      className="voucher_entry_account_input"
                      onChange={(e) =>
                        handleChange(e, index, "item_name", e.target.value)
                      }
                      onKeyUp={(e) =>
                        handleChange(e, index, "item_name", e.target.value)
                      }
                      onFocus={(e) =>
                        handleFocus(e, index, "item_name", e.target.value)
                      }
                      onBlur={(e) =>
                        handleBlur(e, index, "item_name", e.target.value)
                      }
                      value={data?.data_item[index]?.item_name || ""}
                    />
                    {modal_state[`item_name${index}`] && (
                      <DropdownVoucherDynamicInput
                        title={"List of Item Name"}
                        state={modal_state[`item_name${index}`]}
                        data={data}
                        setData={setData}
                        input_value={item?.item_name}
                        input_key={"item_name"}
                        input_id={"item_id"}
                        input_blc={""}
                        rawData={itemData}
                        index={index}
                        ref={inputRefs.current[`item_name${index}`]}
                        refs={inputRefs}
                        narr_ref={narr_ref}
                        handleDropdownClick={handleDropdownDynamicClick}
                        isDynamic={true}
                        // setSubmitConfirm={setSubmitConfirm}
                      />
                    )}
                  </div>
                  <div
                    className={`col-1 font_size p-0 m-0 pe-1 font-weight-bold ${
                      data?.location === "Any" ? `` : ""
                    }`}
                    style={{ width: "5%" }}
                  ></div>
                  {data?.data_item[index]?.item_name !== "" ? (
                    <>
                      {data?.location === "Any" ? (
                        <div className="col-2 m-0 p-0 container_of_voucher_dynamic_input">
                          <input
                            type="text"
                            style={{ textAlign: "left" }}
                            name={`godown_location${index}`}
                            ref={(el) => {
                              inputRefs.current[`godown_location${index}`] = el;
                            }}
                            className="voucher_entry_account_input"
                            onChange={(e) =>
                              handleChange(
                                e,
                                index,
                                "godown_location",
                                e.target.value
                              )
                            }
                            onKeyUp={(e) =>
                              handleChange(
                                e,
                                index,
                                "godown_location",
                                e.target.value
                              )
                            }
                            onFocus={(e) =>
                              handleFocus(
                                e,
                                index,
                                "godown_location",
                                e.target.value
                              )
                            }
                            onBlur={(e) =>
                              handleBlur(
                                e,
                                index,
                                "godown_location",
                                e.target.value
                              )
                            }
                            value={
                              data?.data_item[index]?.godown_location || ""
                            }
                          />
                          {modal_state[`godown_location${index}`] && (
                            <DropdownVoucherDynamicInput
                              title={"List of Godown"}
                              state={modal_state[`godown_location${index}`]}
                              data={data}
                              setData={setData}
                              input_value={
                                data?.data_item[index]?.godown_location
                              }
                              input_key={"godown_location"}
                              input_id={"godown_location_id"}
                              rawData={godownLocationItem}
                              index={index}
                              ref={inputRefs.current[`godown_location${index}`]}
                              handleDropdownClick={handleDropdownDynamicClick}
                              // setSubmitConfirm={setSubmitConfirm}
                            />
                          )}
                        </div>
                      ) : (
                        <div className="col-2 m-0 p-0 container_of_voucher_dynamic_input"></div>
                      )}
                      {data?.data_item[index]?.is_unit_available ? (
                        <>
                          <div
                            className={`col-1 m-0 p-0 font-weight-bold container_of_voucher_dynamic_input`}
                          >
                            <input
                              type="text"
                              // disabled={data?.data_item[index]?.is_unit_available === '' || data?.data_item[index]?.is_unit_available === 'Not Applicable'}
                              style={{ textAlign: "right", paddingRight: 5 }}
                              name={`item_qty${index}`}
                              ref={(el) => {
                                inputRefs.current[`item_qty${index}`] = el;
                              }}
                              className="voucher_entry_account_input"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  index,
                                  "item_qty",
                                  e.target.value
                                )
                              }
                              onKeyUp={(e) =>
                                handleChange(
                                  e,
                                  index,
                                  "item_qty",
                                  e.target.value
                                )
                              }
                              onFocus={(e) =>
                                handleFocus(
                                  e,
                                  index,
                                  "item_qty",
                                  e.target.value
                                )
                              }
                              onBlur={(e) =>
                                handleBlur(e, index, "item_qty", e.target.value)
                              }
                              value={data?.data_item[index]?.item_qty || ""}
                            />
                          </div>

                          <div className="col-1 m-0 container_of_voucher_dynamic_input p-0">
                            <input
                              type="text"
                              readOnly
                              style={{ textAlign: "right", paddingRight: 5 }}
                              className="voucher_entry_account__dynamic_input"
                              value={
                                data?.data_item[index]?.combination_of_units
                              }
                            />
                            {/* <p className='voucher_entry_account_input'>({item_entry[index]?.combination_of_units})</p> */}
                          </div>
                          {data?.data_item[index]?.item_qty !== "" ? (
                            <>
                              <div
                                className="col-1 m-0 container_of_voucher_dynamic_input  p-0"
                                style={{ width: "10.1%" }}
                              >
                                <input
                                  type="text"
                                  style={{
                                    textAlign: "right",
                                    paddingRight: 5,
                                  }}
                                  name={`item_rate${index}`}
                                  ref={(el) => {
                                    inputRefs.current[`item_rate${index}`] = el;
                                  }}
                                  className="voucher_entry_account_input"
                                  onChange={(e) =>
                                    handleChange(
                                      e,
                                      index,
                                      "item_rate",
                                      e.target.value
                                    )
                                  }
                                  onKeyUp={(e) =>
                                    handleChange(
                                      e,
                                      index,
                                      "item_rate",
                                      e.target.value
                                    )
                                  }
                                  onFocus={(e) =>
                                    handleFocus(
                                      e,
                                      index,
                                      "item_rate",
                                      e.target.value
                                    )
                                  }
                                  onBlur={(e) =>
                                    handleBlur(
                                      e,
                                      index,
                                      "item_rate",
                                      e.target.value
                                    )
                                  }
                                  value={
                                    data?.data_item[index]?.item_rate || ""
                                  }
                                />
                              </div>
                            </>
                          ) : (
                            <div
                              className="col-1 m-0 container_of_voucher_dynamic_input  p-0"
                              style={{ width: "10.1%" }}
                            ></div>
                          )}
                          {data?.data_item[index]?.item_qty !== "" ? (
                            <>
                              <div
                                className="col-1 m-0 container_of_voucher_dynamic_input  p-0 position-relative"
                                style={{ width: "5%" }}
                              >
                                <input
                                  type="text"
                                  style={{ textAlign: "left" }}
                                  name={`per_unit${index}`}
                                  ref={(el) => {
                                    inputRefs.current[`per_unit${index}`] = el;
                                  }}
                                  className="voucher_entry_account_input"
                                  onChange={(e) =>
                                    handleChange(
                                      e,
                                      index,
                                      "per_unit",
                                      e.target.value
                                    )
                                  }
                                  onKeyUp={(e) =>
                                    handleChange(
                                      e,
                                      index,
                                      "per_unit",
                                      e.target.value
                                    )
                                  }
                                  onFocus={(e) =>
                                    handleFocus(
                                      e,
                                      index,
                                      "per_unit",
                                      e.target.value
                                    )
                                  }
                                  onBlur={(e) =>
                                    handleBlur(
                                      e,
                                      index,
                                      "per_unit",
                                      e.target.value
                                    )
                                  }
                                  value={data?.data_item[index]?.per_unit || ""}
                                />
                                {modal_state[`per_unit${index}`] && (
                                    <DropdownVoucherDynamicInput
                                      custom_class={"dropdown-content-list-per-unit"}
                                      title={"List of Units"}
                                      state={modal_state[`per_unit${index}`]}
                                      data={data}
                                      setData={setData}
                                      input_value={data?.data_item[index]?.per_unit}
                                      input_key={"per_unit"}
                                      input_id={"per_unit_id"}
                                      rawData={data?.data_item[index]?.item_units}
                                      index={index}
                                      ref={inputRefs.current[`per_unit${index}`]}
                                      refs={inputRefs}
                                      narr_ref={narr_ref}
                                      handleDropdownClick={handleDropdownDynamicClick}
                                    />
                                )}
                              </div>
                            </>
                          ) : (
                            <div
                              className="col-1 m-0 container_of_voucher_dynamic_input  p-0"
                              style={{ width: "5%" }}
                            ></div>
                          )}
                        </>
                      ) : (
                        <div className="col-3" style={{ width: "31.8%" }}></div>
                      )}

                      <div
                        className={`${
                          data?.data_item[index]?.is_unit_available
                            ? "col"
                            : "col"
                        } m-0 p-0 container_of_voucher_dynamic_input`}
                      >
                        <input
                          type="text"
                          style={{ textAlign: "right", paddingRight: 5 }}
                          name={`item_amt${index}`}
                          ref={(el) => {
                            inputRefs.current[`item_amt${index}`] = el;
                          }}
                          className="voucher_entry_account_input"
                          onChange={(e) =>
                            handleChange(e, index, "item_amt", e.target.value)
                          }
                          onKeyUp={(e) =>
                            handleChange(e, index, "item_amt", e.target.value)
                          }
                          onFocus={(e) =>
                            handleFocus(e, index, "item_amt", e.target.value)
                          }
                          onBlur={(e) =>
                            handleBlur(e, index, "item_amt", e.target.value)
                          }
                          value={data?.data_item[index]?.item_amt || ""}
                        />
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            );
          })}
       
          {data?.data_item.map((item, index) => {
            return item?.check_open
              ? data?.sale_ledger_data?.map((item1, index1) => {
                  return (
                    <div
                      key={index1}
                      className={`col-12 ${
                        data?.sale_ledger_data[index1]?.check
                          ? ""
                          : ``
                      } `}
                      style={{ height: 19.5, backgroundColor: "transparent" }}
                    >
                      <div className="row" style={{ height: 19.5 }}>
                        <div className="col-1" style={{ width: "3%" }}></div>
                        <div
                          className={`col-10 m-0  p-0 ${
                            data?.sale_ledger_data[index1]?.check
                              ? ""
                              : ``
                          } `}
                        >
                          <div className="row m-0 p-0" style={{ height: 19.5 }}>
                            <div
                              className="col-4 m-0 p-0 container_of_voucher_dynamic_input"
                              style={{ height: 19.5 }}
                            >
                              <input
                                type="text"
                                name={`ledger_account${index1}`}
                                ref={(el) => {
                                  inputRefs.current[`ledger_account${index1}`] =
                                    el;
                                }}
                                className="voucher_entry_account_input"
                                onChange={(e) =>
                                  handleChange(
                                    e,
                                    index1,
                                    "ledger_account",
                                    e.target.value
                                  )
                                }
                                onKeyUp={(e) =>
                                  handleChange(
                                    e,
                                    index1,
                                    "ledger_account",
                                    e.target.value
                                  )
                                }
                                onFocus={(e) =>
                                  handleFocus(
                                    e,
                                    index1,
                                    "ledger_account",
                                    e.target.value
                                  )
                                }
                                onBlur={(e) =>
                                  handleBlur(
                                    e,
                                    index1,
                                    "ledger_account",
                                    e.target.value
                                  )
                                }
                                value={
                                  data?.sale_ledger_data[index1]
                                    ?.ledger_account || ""
                                }
                              />
                              {modal_state[`ledger_account${index1}`] && (
                                <DropdownForItemLedgerDynamic
                                  title={"List of Ledger Account"}
                                  state={modal_state[`ledger_account${index1}`]}
                                  data={data}
                                  setData={setData}
                                  input_value={
                                    data?.sale_ledger_data[index1]
                                      ?.ledger_account
                                  }
                                  input_key={"ledger_account"}
                                  input_id={"ledger_account_id"}
                                  input_blc={""}
                                  rawData={itemLedgerData}
                                  index={index1}
                                  ref={
                                    inputRefs.current[`ledger_account${index1}`]
                                  }
                                  handleDropdownClick={handleDropdownDynamicClick}
                                  // setSubmitConfirm={setSubmitConfirm}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        {data?.sale_ledger_data[index1]?.check ? null : (
                          <>
                            <div
                              className={
                                "col m-0  p-0 container_of_voucher_dynamic_input"
                              }
                            >
                              <input
                                type="text"
                                style={{ textAlign: "right", paddingRight: 5 }}
                                name={`ledger_amount${index1}`}
                                ref={(el) => {
                                  inputRefs.current[`ledger_amount${index1}`] =
                                    el;
                                }}
                                className="voucher_entry_account_input"
                                onChange={(e) =>
                                  handleChange(
                                    e,
                                    index1,
                                    "ledger_amount",
                                    e.target.value
                                  )
                                }
                                onKeyUp={(e) =>
                                  handleChange(
                                    e,
                                    index1,
                                    "ledger_amount",
                                    e.target.value
                                  )
                                }
                                onFocus={(e) =>
                                  handleFocus(
                                    e,
                                    index1,
                                    "ledger_amount",
                                    e.target.value
                                  )
                                }
                                onBlur={(e) =>
                                  handleBlur(
                                    e,
                                    index1,
                                    "ledger_amount",
                                    e.target.value
                                  )
                                }
                                value={
                                  data?.sale_ledger_data[index1]
                                    ?.ledger_amount || ""
                                }
                              />
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  );
                })
              : null;
          })}
        </div>
      </div>
    </div>
  );
};
